import { Component, OnInit, Input } from '@angular/core';
import { Router } from '@angular/router';
import { MatDialogRef, MatDialog } from '@angular/material/dialog';
import { TylerMatTableDataSource } from '../../../shared-components/angular-material/extended.class';
import { detailExpand } from '../../../shared-components/angular-material/mat-animations';
import { AriaDirective } from '../../../shared-components/directives/aria.directive';

import { LoginService } from '../../../shared-modules/login/login.service';
import { StudentService } from '../../../shared-components/student/student.service';
import { LoginSettings } from '../../../shared-modules/login/loginSetting.model';
import { CourseSchedule } from '../../../shared-components/student/course-schedule.model';
import { SendEmailService } from '../../../shared-modules/send-email/send-email.service';
import { ReportCardGradesTerm, GradesData, GradesBehaviorSocialSkills } from '../grades.model';
import { CourseDescriptionComponent } from '../course-description/course-description.component';
import { CommentsAndBehaviorMarksComponent } from '../comments-and-behavior-marks/comments-and-behavior-marks.component';
import { ProfileViewerDialogComponent } from '../../../shared-components/profile-viewer-dialog/profile-viewer-dialog.component';
import { Subscription } from 'rxjs';
import { AssignmentService } from '../../assignment/assignment.service';
import { UserService } from '../../../shared-components/user/user.service';
import { SchoolYearSettings } from '../../../shared-components/year/school-year-settings.model';
import { take } from 'rxjs/operators';
@Component({
    selector: 'app-traditional-grades',
    templateUrl: './traditional-grades.component.html',
    styleUrls: ['../grades.component.css'],
    animations: [detailExpand]
})
export class TraditionalGradesComponent implements OnInit {

    @Input() studentSchedules: CourseSchedule[];
    @Input() studentTerms: ReportCardGradesTerm[];
    @Input() showAssignmentLink: boolean;
    @Input() showAttendanceLink: boolean;
    @Input() showSendEmailLink: boolean;
    @Input() isProgressGrades: boolean;
    @Input() isBusy: boolean;
    @Input() gradesBehaviorSocialSkills: GradesBehaviorSocialSkills[];
    @Input() schoolYearSettings: SchoolYearSettings[];
    studentEnrollment = this.studentService.studentEnrollment;
    traditionalGrades: GradesData[] = [];
    courseDescriptionDialogRef: MatDialogRef<CourseDescriptionComponent>;
    commentsAndBehaviorMarksDialogRef: MatDialogRef<CommentsAndBehaviorMarksComponent>;
    profileViewerDialogRef: MatDialogRef<ProfileViewerDialogComponent>;
    selectedStudentSubscription: Subscription;
    enableClassInfoTeacherProfiles = false;

    constructor(
        private router: Router,
        private dialog: MatDialog,
        private loginService: LoginService,
        private studentService: StudentService,
        private sendEmailService: SendEmailService,
        private assignmentService: AssignmentService,
        private userService: UserService,
    ) {
        this.selectedStudentSubscription = this.studentService.selectedStudentStream$.subscribe(studentId => {
            if (studentId > 0) {
                this.studentEnrollment = this.studentService.studentEnrollment;
            }
        });
    }

    ngOnInit() {
        this.enableClassInfoTeacherProfiles = this.loginService.LoginSettings.EnableClassInformationandTeacherProfiles;
        this.studentEnrollment = this.studentService.studentEnrollment;
        if (this.studentEnrollment != undefined) {
            this.getTraditionalGrades();
        } else {
            this.selectedStudentSubscription = this.studentService.selectedStudentStream$.subscribe(
                studentId => {
                    if (studentId > 0) {
                        this.studentEnrollment = this.studentService.studentEnrollment;
                    }
                });
        }
    }

    getTraditionalGrades() {
        this.traditionalGrades = [];
        this.studentSchedules.forEach(function (schedule) {
            if (schedule.ShowTraditionalTab == true) {
                if (this.traditionalGrades.filter(o => o.SchoolName == schedule.SchoolName).length == 0) {
                    const siteYearId: number = schedule.SiteYearId;
                    const schoolName: string = schedule.SchoolName;
                    const studentSchedulesData = this.studentSchedules.filter(o => o.SchoolName == schoolName && o.ShowOnGradesPage == true && o.ShowTraditionalTab == true);
                    let terms = [];
                    if (this.isProgressGrades == true) {
                        terms = this.studentTerms.filter(o => o.SchoolName == schoolName);
                    } else {
                        this.studentTerms.forEach(term => {
                            if (term.GradingTerm.indexOf('P') < 0 && term.SchoolName == schoolName) {
                                terms.push(term);
                            }
                        });
                    }
                    this.traditionalGrades.push({
                        SiteYearId: siteYearId,
                        SchoolName: schoolName,
                        Terms: terms,
                        AngularMatData: new TylerMatTableDataSource(studentSchedulesData)
                    });
                }
            }
        }.bind(this));
    }

    getColumnsToDisplay(terms: ReportCardGradesTerm[], siteYearId: number) {
        const columnsToDisplay: string[] = ['More', 'Meets', 'Term', 'Course', 'Teacher'];
        const schoolYearSettings: SchoolYearSettings = this.schoolYearSettings.filter(o => o.Id == siteYearId)[0];
        const isProgressGrades: boolean = this.isProgressGrades;
        for (const term of terms) {
            if (schoolYearSettings != null && ((schoolYearSettings.UsingFinalGrade && term.GradingTerm.indexOf('Y') > -1)
                || (schoolYearSettings.UsingSemesterGrades && (term.GradingTerm.indexOf('S') > -1) || term.GradingTerm.indexOf('X') > -1)
                || (schoolYearSettings.UsingTermGrades && term.GradingTerm.indexOf('T') > -1)
                || ((schoolYearSettings.UsingProgressGrades || isProgressGrades == true) && term.GradingTerm.indexOf('P') > -1))) {
                columnsToDisplay.push(term.GradingTerm);
            }
        }
        return columnsToDisplay;
    }

    viewAssignments(course: CourseSchedule, gradingTerm: string) {
        this.assignmentService.selectedCourse = course;
        this.assignmentService.selectedSectionId = course.SiteSectionId;
        this.assignmentService.selectedCourseSection = course.SubjectCode + '-' + course.Section;
        this.assignmentService.selectedGP = gradingTerm;
        this.assignmentService.preventTabSwitch = true;
        if (!this.userService.studentInformationView) {
            this.router.navigateByUrl('/student360/assignments');
        }
        else {
            this.userService.updateStudentViewRoute('/student360/assignments');
        }
    }

    viewAttendance(course: CourseSchedule) {
        this.studentService.selectedCourse = course;
        this.studentService.selectedSectionId = course.SiteSectionId;
        this.studentService.selected = '3';
        if (!this.userService.studentInformationView) {
            this.router.navigateByUrl('/student360/attendance');
        }
        else {
            this.userService.updateStudentViewRoute('/student360/attendance');
        }
    }

    sendEmail(course: CourseSchedule) {
        if (course.TeacherEmail != null && course.TeacherEmail != '') {
            this.sendEmailService.teacherName = course.TeacherName;
            this.sendEmailService.teacherEmailAddress = course.TeacherEmail;
            if (!this.userService.studentInformationView) {
                this.router.navigateByUrl('/student360/sendEmail');
            }
            else {
                this.userService.updateStudentViewRoute('/student360/sendEmail');
            }
        }
    }

    viewCourseDescription(subjectId: number) {
        const studentSchedule = this.studentSchedules.filter(function (o) { return o.Id == subjectId; })[0];
        this.courseDescriptionDialogRef = this.dialog.open(CourseDescriptionComponent, {
            panelClass: 'tyl-mat-dialog',
            maxWidth: '450px',
            data: { studentSchedule: studentSchedule }
        });
    }

    viewCourseProfile(course: CourseSchedule) {
        this.profileViewerDialogRef = this.dialog.open(ProfileViewerDialogComponent, {
            data: {
                // eslint-disable-next-line camelcase
                courseSSEC_ID: course.SiteSectionId,
                courseName: course.Course,
                courseSection: course.SubjectCode + '-' + course.Section,
                teacherId: course.TeacherMemId,
                teacherName: course.TeacherName,
                school: course.SchoolName,
                profiles: course.CourseProfile,
                showTeacherProfileLink: course.HasTeacherProfile
            },
            disableClose: true
        });

        this.profileViewerDialogRef.componentInstance.teacherProfileClick.pipe(take(1)).subscribe(() => {
            this.viewTeacherProfile(course);
        });
    }

    viewTeacherProfile(course: CourseSchedule) {
        this.profileViewerDialogRef = this.dialog.open(ProfileViewerDialogComponent, {
            data: {
                teacherId: course.TeacherMemId,
                teacherName: course.TeacherName,
                school: course.SchoolName,
                profiles: course.TeacherProfile
            },
            disableClose: true
        });
    }

    // eslint-disable-next-line complexity
    commentsAndBehaviorMarksClick(course: CourseSchedule, termGrade: ReportCardGradesTerm) {
        let grade: string = termGrade.Grade;
        let isGradeBookGrade: boolean = termGrade.IsGradeBookGrade;
        let gpDesc = termGrade.GradingTermDescription;

        if (grade == null) {
            grade = '';
        }

        if (grade.length == 0) {
            return false;
        }

        if (this.showAssignmentLink == false) {
            isGradeBookGrade = false;
            gpDesc = '';
        }
        else if (isGradeBookGrade == false && termGrade.IsGradeBookExists) {
            isGradeBookGrade = true;
        }

        if (isGradeBookGrade == true && ((termGrade.Comment != null && termGrade.Comment.length > 0) || (termGrade.Workhabits != null && termGrade.Workhabits.length > 0) || (termGrade.Citizenship != null && termGrade.Citizenship.length > 0))) {
            this.showCommentsAndBehaviorMarksPopUp(course, termGrade, isGradeBookGrade, gpDesc);
        }
        else if ((termGrade.Comment != null && termGrade.Comment.length > 0) || (termGrade.Workhabits != null && termGrade.Workhabits.length > 0) || (termGrade.Citizenship != null && termGrade.Citizenship.length > 0)) {
            this.showCommentsAndBehaviorMarksPopUp(course, termGrade, isGradeBookGrade, gpDesc);
        }
        else if (isGradeBookGrade == true || (isGradeBookGrade == false && gpDesc != undefined && gpDesc != '')) {
            let gradingTerm: string = termGrade.GradingTerm;
            if (gradingTerm.indexOf('X') == 0) {
                gradingTerm = gradingTerm.replace('X', 'S');
            }
            // Get parent Term for progress grades
            if (this.isProgressGrades == true && gradingTerm.indexOf('P') > -1) {
                for (let i = 0; i < this.studentTerms.length; i++) {
                    if (this.studentTerms[i].GradingTerm == gradingTerm) {
                        for (let j = i + 1; j < this.studentTerms.length; j++) {
                            if (this.studentTerms[j].GradingTerm.indexOf('T') > -1) {
                                gradingTerm = this.studentTerms[j].GradingTerm;
                                break;
                            }
                        }
                        break;
                    }
                }
            }

            this.viewAssignments(course, gradingTerm);
        }
    }

    showCommentsAndBehaviorMarksPopUp(course: CourseSchedule, termGrade: ReportCardGradesTerm, isGradeBookGrade: boolean, gpDesc: string) {
        let behaviorSocialSkillDescription = 'Behavior/SocialSkills';
        const behaviorSocialSkill = this.gradesBehaviorSocialSkills.filter(o => o.SiteYearId == course.SiteYearId)[0];
        if (behaviorSocialSkill != null) {
            behaviorSocialSkillDescription = behaviorSocialSkill.behaviorSocialSkillDescription;
        }

        this.commentsAndBehaviorMarksDialogRef = this.dialog.open(CommentsAndBehaviorMarksComponent, {
            panelClass: 'tyl-mat-dialog',
            minWidth: '500px',
            data: {
                selectedGradeId: course.Id,
                selectedIsStandardView: false,
                selectedGradingTerm: termGrade.GradingTerm,
                gradingTermDesc: gpDesc,
                selectedStandard: 'none',
                isGradeBookGrade: isGradeBookGrade,
                selectedSubjectCode: course.SubjectCode,
                selectedSection: course.Section,
                selectedId: null,
                gradingScale: course.GradingCycle,
                schoolName: course.SchoolName,
                isTermSelected: false,
                studentSchedules: this.studentSchedules,
                course: course,
                termGrade: termGrade,
                behaviorSocialSkillDescription: behaviorSocialSkillDescription
            }
        });
    }

    showCategoryScores(course: CourseSchedule) {
        return course.CategoryAverages != undefined && course.CategoryAverages.length > 0;
    }

    getCategoryAverage(course: CourseSchedule, category, term) {
        const average = course.CategoryAverages.filter(c => c.TermId == term.Id && c.CategoryName == category.Name)[0];
        return (average != undefined) ? average.CategoryAverage : '';
    }

    actionMenuClick(menuName: string, course: CourseSchedule) {
        switch (menuName) {
            case 'Course Description':
                this.viewCourseDescription(course.Id);
                break;
            case 'Class Information':
                this.viewCourseProfile(course);
                break;
            case 'Teacher Profile':
                this.viewTeacherProfile(course);
                break;
        }
    }

    checkExpanded(row: any): boolean {
        return this.traditionalGrades[0].AngularMatData.checkExpanded(row);
    }

    toggleExpanded(row: any) {
        return this.traditionalGrades[0].AngularMatData.toggleExpanded(row);
    }

    expandAll(expand: boolean) {
        return this.traditionalGrades.forEach((tr, index) => {
            this.traditionalGrades[index].AngularMatData.expandAll(expand);
        });
    }

    // ------------Aria/Accessibility---------------------------

    getAriaRow(row: CourseSchedule, terms: ReportCardGradesTerm[]): string {
        let colList: string[] = [];
        colList = this.getColumnsToDisplay(terms, row.SiteYearId);

        const dataList: string[] = [row.Meets,
        row.Term,
        row.Course,
        row.Teacher];
        for (let i = 0; i < terms.length; i++) {
            const detailObject = row.ReportCardGradesTerms.filter(o => o.GradingTerm == terms[i].GradingTerm);
            for (let j = 0; j < detailObject.length; j++) {
                dataList.push(detailObject[j].DisplayGrade);
            }
        }
        return AriaDirective.concatAriaStrings(colList, dataList);
    }

    getAriaDetailRow(row: CourseSchedule): string {
        const colList: string[] = ['Course-Section', 'Credits Attempted/Earned'];
        const dataList: string[] = [
            row.SubjectCode.concat('-', row.Section),
            row.CreditAttempted.toString().concat('/', row.CreditEarned.toString()),
        ];
        return AriaDirective.concatAriaStrings(colList, dataList);
    }
}
